import { css } from 'styled-components';
/** @deprecated */
export const moz = (...args) => css `
  /* stylelint-disable-next-line at-rule-no-vendor-prefix -- deprecated, but intentional */
  @-moz-document url-prefix() {
    ${css(...args)};
  }
`;
export const ie = (...args) => css `
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    ${css(...args)};
  }
`;
export const edge = (...args) => css `
  @supports (-ms-accelerator: true) {
    ${css(...args)};
  }
`;
//# sourceMappingURL=target-vendor.js.map